import { IconBrandInstagram, IconBrandLinkedin } from "@tabler/icons-react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <>
            <footer className="footer">
                <div className="container">
                    <div className="py-3">
                        <div className="row g-lg-4 align-items-center">
                            <div className="col-lg-6">
                                <div className="row g-lg-4">
                                    <div className="col-md">
                                        <div className="subheader mb-3">Nossos Produtos</div>
                                        <ul className="list-unstyled list-separated gap-2">
                                            <li>
                                                <a className="link-secondary" href="">
                                                    ERP
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-md">
                                        <div className="subheader mb-3">Suporte</div>
                                        <ul className="list-unstyled list-separated gap-2">
                                            <li>
                                                <a className="link-secondary" href="">
                                                    Contato
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 ml-auto">
                                <div className="text-secondary fs-4">
                                    Agradecimentos especiais a <strong className="text-nowrap">Matheus Henrique Wasem</strong> pela criação do design e identidade visual e <strong className="text-nowrap">Jonathan Igor Bockorny Pereira</strong> pela co-participação na criação da LineXS.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <footer className="footer">
                <div className="container">
                    <div className="py-3 border-top-light text-center text-lg-start">
                        <div className="row g-lg-4">
                            <div className="col-lg-auto text-lg-end order-lg-last">
                                <div className="row justify-center">
                                    <div className="col-auto">
                                        <ul className="list-inline list-inline-dots">
                                            <li className="list-inline-item">
                                                <Link className="link-secondary" to="/termos-de-uso">
                                                    Termos de Uso
                                                </Link>
                                            </li>
                                            <li className="list-inline-item">
                                                <Link className="link-secondary" to="/politica-de-privacidade">
                                                    Política de Privacidade
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg">
                                LineXS © {new Date().getFullYear()}. Todos os direitos reservados.
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}